













































import Vue from "vue";
import { Component } from "vue-property-decorator";
import Env from '@/services/Env'
import SmtpSender from '@/services/SmtpSender'


@Component({
  name: "BaseContactForm",
  props: {
    subtitle: String,
    title: {
      type: String,
      default: "MAIL US YOUR MESSAGE",
    },
  },
  inject: ["theme"],
})
export default class BaseContactForm extends Vue {

  public sentTo = Env.officeEmail;

  public name = null;
  public email = '';
  public subject = '';
  public message = '';

  private snackbar = false;
  private text =  this.$t("sections.KeepInTouch.form.sent") ;
  private timeout = 2000;

  async sendSmtp() {
    const message = {from: this.email, subject: this.subject, body: this.message , name: this.name};
    try{
      await SmtpSender.sendSmtp(message);
      this.snackbar = true;
      this.subject = '';
      this.message = '';
    }catch(e){
      console.warn(e);
      await SmtpSender.openMailBox(message);
    }
  }
}
